export default __webpack_public_path__ + "static/media/soft launch.53bd129d.svg";